import React from "react";
import { Cascader, Form, Input, InputNumber, Switch } from "antd";
import { IColumnData } from "@Utils";

export type IInputType = "cascader" | "number" | "text" | "switch";
export interface IEditableCellProps extends IMergeColumns<unknown>, React.HTMLAttributes<HTMLElement> {
  initialValue: unknown;
  children: React.ReactNode;
}

interface IMergeColumns<T> extends Omit<IColumnData<T>, "children" | "title" | "onReset"> {
  dataIndex: string;
  editing: boolean; // not yet used
  initialValue: unknown;
  inputType: IInputType;
  name: string | string[];
  record: Record<string, unknown>;
  props: Record<string, unknown>;
}

const YES_NO_SWITCH_PROPS = {
  checkedChildren: "Yes",
  unCheckedChildren: "No",
};

export function mergedColumns<T = unknown>(
  columns: IColumnData<T>[],
  sectionName: string,
  initialValues: Record<string, unknown>
): IColumnData<T>[] {
  return columns.map((col) => {
    return {
      ...col,
      onCell: (record: T, name: number) => ({
        align: "center",
        dataIndex: col.key,
        initialValue: initialValues[col.key.toString()],
        inputType: col.inputType,
        messageVariables: col.messageVariables,
        name: col.key !== "delete" ? [sectionName, name, col.key] : [],
        props: col.props,
        record,
        render: col.render,
        rules: col.rules,
        title: undefined,
      }),
    };
  });
}
const EditableCell: React.FC<IEditableCellProps> = ({
  children,
  dataIndex,
  initialValue,
  inputType,
  messageVariables,
  name,
  props: inputProps = {},
  record,
  render,
  rules,
  ...otherProps
}) => {
  const getInputNode = (type: IInputType) => {
    switch (type) {
      case "cascader":
        return <Cascader {...inputProps} />;
      case "number":
        return <InputNumber {...inputProps} />;
      case "switch":
        return <Switch defaultChecked={initialValue as boolean} {...YES_NO_SWITCH_PROPS} {...inputProps} />;
      case "text":
        return <Input {...inputProps} />;
      default:
        return <Input {...inputProps} />;
    }
  };

  const inputNode = render ? children : getInputNode(inputType);

  return (
    <td {...otherProps}>
      <Form.Item
        initialValue={initialValue}
        messageVariables={messageVariables}
        name={name?.length > 0 ? name : undefined}
        rules={rules}
        valuePropName={inputType !== "switch" ? "value" : "checked"}
      >
        {inputNode}
      </Form.Item>
    </td>
  );
};

export default EditableCell;
